<template>
  <v-card>
    <v-card-title>
      <v-text-field
        autofocus
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        label="Buscar producto...."
        single-line
        @keyup.enter="buscarProducto"
        hide-details
      ></v-text-field>
      <v-btn class="ml-5" color="green" dark to="/productos/creareditar">
        <v-icon>mdi-package-variant-plus</v-icon>
      </v-btn>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="getProductosActivos"
      :search="search"
    >
      <template v-slot:[`item.stockactual`]="{ item }">
        <strong style="color: #43A047" v-if="!item.articulo.controlstock"
          >DISPONIBLE</strong
        >
        <p v-else-if="item.stockactual > 0">{{ item.stockactual }}</p>
        <strong style="color: #F4511E" v-else>AGOTADO</strong>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          icon
          color="blue"
          @click="pusCarrito(item)"
          v-if="item.stockactual > 0 || !item.articulo.controlstock"
        >
          <v-icon>mdi-plus-box</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "TablaProductos",
  data: () => ({
    search: "",
    headers: [
      { text: "Cod.", align: "center", value: "articulo.codigo" },
      { text: "Nombre", value: "articulo.nombre" },
      { text: "Ubicacion", value: "ubicacion" },
      { text: "Stock", align: "center", value: "stockactual" },
      {
        text: "Precio Venta",
        align: "center",
        value: "articulo.preciosugerido",
      },
      {
        text: "Precio Minimo",
        align: "center",
        value: "articulo.preciominimo",
      },
      { text: "Actions", align: "center", value: "actions", sortable: false },
    ],
  }),
  computed: {
    ...mapGetters(["getProductosActivos", "getTokenUser"]),
  },
  methods: {
    buscarProducto() {
        const producto = this.getProductosActivos.filter(
            (item) => item.articulo.codigo == this.search
      );

      if (producto[0]) {
        this.pusCarrito(producto[0]);
      } else {
        //this.infoSwal("Error", "El producto no se encontró");
      }
      this.search = "";
    },

    pusCarrito(item) {
      this.$emit("setdata", item);
    },
    getColor(item) {
      if (!item.articulo.controlstock) return "green";
      else if (item.stockactual < item.minimo) return "red";
      else return "green";
    },
  },
};
</script>
